module.exports = __webpack_public_path__ + "static/img/08.ddb627d9.png";